import {client} from "@/store";
import Vue from "vue";

export default {
	namespaced: true,

	state: {
		roles: []
	},

	// sync actions
	mutations: {
		setRoles(state, value) {
			Vue.set(state, 'roles', [...value]);
		},

		updateRole(state, value) {
			state.roles = [
				...state.roles.filter(item => item.id !== value.id),
				value
			];
			Vue.set(state, 'roles', [...state.roles]);
		},
	},
	getters: {
		getRoleById: state => id => {
			return state.roles.find(item => item.id === id);
		}
	},

	// async actions
	actions: {
		fetchRoles({ commit, state, dispatch }, data) {
			const rolesQuery = `
			query {
				getRoles {
					id,
					name,
					constant
				}
			}`;

			return new Promise((resolve, reject) => {
				commit('setLoading', null, { root: true });
				client.query(rolesQuery, { ...data }).then(result => {
					commit('setIdle', null, { root: true });
					commit('setRoles', result.getRoles);
					resolve(result.getRoles);
				});
			});
		},

		fetchRoleById({ commit, state, dispatch }, data) {
			const projectQuery = `
			query ($id: Int!) {
				getRoleById(id: $id) {
					id,
					name,
					constant
				}
			}`;
			return new Promise((resolve, reject) => {
				commit('setLoading', null, { root: true });
				client.query(projectQuery, { id: data }).then(result => {
					commit('setIdle', null, { root: true });
					commit('updateRole', result.getRoleById);
					resolve(result.getRoleById);
				});
			});
		},

		fetchRoleByConstant({ commit, state, dispatch }, data) {
			const projectQuery = `
			query ($constant: String!) {
				getRoleByConstant(constant: $constant) {
					id,
					name,
					constant
				}
			}`;
			return new Promise((resolve, reject) => {
				commit('setLoading', null, { root: true });
				client.query(projectQuery, { id: data }).then(result => {
					commit('setIdle', null, { root: true });
					commit('updateRole', result.getRoleByConstant);
					resolve(result.getRoleByConstant);
				});
			});
		}
	}
};
